import React from 'react'
import { Provider } from 'react-redux'
import type { IBasePropsState } from '@src/slices/base-props.slice'
import { store } from '@src/store'
import { ExternalComponentProvider } from '@src/context/ExternalComponentsContext'
import { TemplatesConfiguration as TemplatesConfigurationComponent } from './TemplatesConfiguration.component'

export const TemplatesConfiguration: React.FC<IBasePropsState> = ({
  context,
  baseUrl,
  resource,
  nodes,
  actionsCallback,
  overwriteColumns,
  permissions,
  isSignatureFlow,
  biometric,
  documentType,
  tags,
  url,
  t,
  handleReturn,
  components,
  filterWorkspaceCallback,
  onDuplicate
}) => {
  return (
    <Provider store={store}>
      <ExternalComponentProvider components={components}>
        <TemplatesConfigurationComponent
          context={context}
          baseUrl={baseUrl}
          resource={resource}
          nodes={nodes}
          actionsCallback={actionsCallback}
          overwriteColumns={overwriteColumns}
          permissions={permissions}
          isSignatureFlow={isSignatureFlow}
          biometric={biometric}
          documentType={documentType}
          tags={tags}
          url={url}
          t={t}
          handleReturn={handleReturn}
          filterWorkspaceCallback={filterWorkspaceCallback}
          onDuplicate={onDuplicate}
        />
      </ExternalComponentProvider>
    </Provider>
  )
}
   